<div class="container-login">
    <div class="box" [ngClass]="{ 'no-item': authOfficeList.length == 0 }">
        <div class="content">
            <div *ngIf="authOfficeList.length> 0" class="office-list">
                <ng-container *ngFor="let office of authOfficeList; let i = index">
                <caremoni-button [buttonType]="buttonType.TV_OFFICE_SELECT" [buttonText]="office.officeNm"
                    [dpad]="DpadZoneType.SCREEN_NON_LAYOUT" [scaledpad]="1" [xdpad]="0" [ydpad]="i"
                    (btnClick)="pickOffice(office)"></caremoni-button>
                </ng-container>
            </div>
        </div>
    </div>
</div>